module.exports = __webpack_public_path__ + "static/img/nav_logo_white_mini.ca49cb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nav_logo_white_mini.png
// module id = 772
// module chunks = 180